const sampleCode = {
  markdown: '### [CodeMirror](http://codemirror.net)\n' +
  'A versatile _text_ editor implemented in **JavaScript*** for the browser. \n' +
  'It is specialized for editing `code`, and comes with a number of language modes and addons that implement more advanced editing functionality.\n',
  javascript: 'var component = {\n\tname: "vue-codemirror",\n\tauthor: "Surmon",\n\trepo: "https://github.com/surmon-china/vue-codemirror"\n};',
  xml: '<!DOCTYPE html>\n' +
  '<html lang="en">\n' +
  '<head>\n' +
  '\n' +
  '  <meta charset="utf-8"/>\n' +
  '  <meta http-equiv="X-UA-Compatible" content="IE=edge"/>\n' +
  '  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>\n' +
  '  <meta name="description" content=""/>\n' +
  '  <meta name="author" content="Łukasz Holeczek"/>\n' +
  '  <meta name="keyword" content=""/>\n' +
  '  <link rel="shortcut icon" href="img/favicon.png"/>\n' +
  '\n' +
  '  <title></title>\n' +
  '\n' +
  '  <!-- Icons -->\n' +
  '  <link href="node_modules/font-awesome/css/font-awesome.min.css" rel="stylesheet"/>\n' +
  '  <link href="node_modules/simple-line-icons/css/simple-line-icons.css" rel="stylesheet"/>\n' +
  '\n' +
  '  <!-- Main styles for this application -->\n' +
  '  <link href="css/style.css" rel="stylesheet"/>\n' +
  '\n' +
  '</head>\n' +
  '\n' +
  '\n' +
  '<body>\n' +
  '  <header class="app-header navbar">\n' +
  '  <h1>I ♥ CoreUI Vue</h1>\n' +
  '  ...\n' +
  '</header>\n' +
  '  <div class="c-body">\n' +
  '    <div class="sidebar">\n' +
  '      ...\n' +
  '    </div>\n' +
  '    <!-- Main content -->\n' +
  '    <main class="main">\n' +
  '\n' +
  '    </main>\n' +
  '  </div>\n' +
  '  <footer class="app-footer">\n' +
  '    ...\n' +
  '  </footer>\n' +
  '\n' +
  '  <!-- Bootstrap and necessary plugins -->\n' +
  '  <script src="node_modules/jquery/dist/jquery.min.js"></script>\n' +
  '  <script src="node_modules/popper.js/dist/umd/popper.min.js"></script>\n' +
  '  <script src="node_modules/bootstrap/dist/js/bootstrap.min.js"></script>\n' +
  '  <script src="node_modules/pace-progress/pace.min.js"></script>\n' +
  '\n' +
  '  <!-- Plugins and scripts required by all views -->\n' +
  '  <script src="node_modules/chart.js/dist/Chart.min.js"></script>\n' +
  '\n' +
  '  <!-- Main scripts -->\n' +
  '  <script src="js/app-config.js"></script>\n' +
  '  <script src="js/app.js"></script>\n' +
  '\n' +
  '</body>\n' +
  '</html>'
}

export default sampleCode
